import { render, staticRenderFns } from "./EditorBubble.vue?vue&type=template&id=56f05ec6&"
import script from "./EditorBubble.vue?vue&type=script&lang=js&"
export * from "./EditorBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports